import React from "react";
const Contact = () => {
  return (
    <>
      <div id="body_wrapper">
        <div class="container">
          <div class="contact-us">
            <h2>Contact Us</h2>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="form-wrapper">
                  <p>
                    We would love to hear from you! If you have any questions,
                    comments, or concerns about our products or services, please
                    don't hesitate to get in touch with us.
                  </p>
                  <p>
                    You can reach us by phone, email, or mail using the
                    information below:
                  </p>
                  <p class="contact-para">
                    <span>
                      Phone: <a href="tel:+917090705000">7090705000</a>
                    </span>
                    <span>
                      Email:{" "}
                      <a href="mailto:chandreshwarwines@gmail.com">
                        chandreshwarwines@gmail.com
                      </a>
                    </span>
                    Address: Shop no 6 & 7 ,Visa Soratita Vanik Niwas, VL Road,
                    Kandivli West Mumbai 400067.
                  </p>
                  <p>
                    Our friendly and knowledgeable staff members will be happy
                    to assist you with any questions you may have and help you
                    find the perfect products for your needs.
                  </p>
                  <p>
                    Alternatively, you can also reach out to us through the
                    contact form below. Simply fill in your name, email address,
                    and message, and we will get back to you as soon as
                    possible.
                  </p>
                  <p>
                    Thank you for choosing Chandreshwar Wines for all your
                    liquor needs. We appreciate your business and look forward
                    to hearing from you soon!
                  </p>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 map_wrap">
                <div class="main-map">
                  <p>
                    If you would like to visit our store in person, we are
                    located at{" "}
                  </p>
                  {/* <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.778004995696!2d72.85152479999999!3d19.2048961!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b6c4ffffffff%3A0xdbceca7d9268d8b0!2sChandreshwar%20Wines!5e0!3m2!1sen!2sin!4v1681545381639!5m2!1sen!2sin"
                    width="550"
                    height="450"
                    style={{ border: "0" }}
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe> */}
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.8866566595857!2d72.83955097453824!3d19.200152248064544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b7118388b57b%3A0x1ced090fb4689442!2sChandreshwar%20wines!5e0!3m2!1sen!2sin!4v1684954336722!5m2!1sen!2sin"
                    title="Chandreshwar Wines"
                    width="600"
                    height="450"
                    // style="border: 0"
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Contact;
